import { useEffect, useState } from 'react';

import { BarChartComponent } from 'components/barChartComponent';
import { DashboardCms } from 'lib/datoCms/queries/getDashboardPage';
import { DropdownRadioMenuFilter } from 'components/dropdownRadioMenuFilter';
import { NoResult } from 'components/noResult';
import { UsersStatisticsResDto } from 'types/swagger';
import { Wrapper } from 'components/wrapper';
import { getAmount } from 'utility/functions';
import styles from './PlayTime.module.scss';
import { useGetLabelByKey } from 'hooks/useLingUI';

const formatter = new Intl.NumberFormat('it-IT', {
  style: 'currency',
  currency: 'EUR',
  // These options are needed to round to whole numbers if that's what you want.
  //minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
  maximumFractionDigits: 2, // (causes 2500.99 to be printed as $2,501)
});

type PlaytimeFilter = {
  label: string;
  value: string;
};
export type PlayTimeProps = {
  playtimeFilters: Array<{ label: string; value: string }>;
  playtimePeriods: Array<{ label: string; value: string }>;
  currPlaytimePeriod: { label: string; value: string };
  setCurrPlaytimePeriod: (el: { label: string; value: string }) => void;
  currPlaytimeFilter: { label: string; value: string }; //'importoTot' | 'tempoTot';
  setCurrPlaytimeFilter: (el: { label: string; value: string }) => void;
  data?: Array<UsersStatisticsResDto> | undefined;
  avarageAmount: number | undefined;
  avarageTime: number | undefined;
  dashboardPage: DashboardCms;
};

export const PlayTime = ({
  playtimeFilters,
  playtimePeriods,
  currPlaytimePeriod,
  setCurrPlaytimePeriod,
  currPlaytimeFilter,
  setCurrPlaytimeFilter,
  data,
  avarageAmount,
  avarageTime,
  dashboardPage,
}: PlayTimeProps) => {
  const [bestResult, setBestResult] = useState<string>('');

  useEffect(() => {
    const maxImportoTotObject =
      data &&
      data.length > 0 &&
      currPlaytimeFilter &&
      data.reduce((prev, current) => {
        return prev[currPlaytimeFilter.value]! > current[currPlaytimeFilter.value]! ? prev : current;
      });
    const verticaleWithMaxImportoTot = maxImportoTotObject && maxImportoTotObject?.verticale;

    verticaleWithMaxImportoTot && setBestResult(verticaleWithMaxImportoTot);
  }, [currPlaytimeFilter, data]);

  const labelMinuto = useGetLabelByKey('minuto');
  const labelMinuti = useGetLabelByKey('minuti');
  const labelOra = useGetLabelByKey('ora');
  const labelOre = useGetLabelByKey('ore');
  const labelAnd = useGetLabelByKey('e');
  const timeFormatter = (n) => {
    const num = n;
    const hours = num / 60;
    const rhours = Math.floor(hours);
    const minutes = (hours - rhours) * 60;
    const rminutes = minutes !== 0 ? Math.round(minutes) : '';
    const hrsPlural = rhours ? (rhours !== 1 ? labelOre : labelOra) : '';
    const and = minutes !== 0 ? labelAnd : '';
    const minPlural = rminutes ? (rminutes !== 1 ? labelMinuti : labelMinuto) : '';
    return `${rhours > 0 ? rhours : ''} ${hrsPlural} ${rhours > 0 ? and : ''} ${rminutes} ${minPlural}`;
  };

  return (
    <Wrapper noPaddingTop={true} noPaddingBottom borderRadius noPaddingLeft={true} noPaddingRight={true}>
      {/* {!isMobile ? ( */}
      <div className={styles.container}>
        <div className={styles.header}>
          <div className={styles.title}>{dashboardPage.titoloPlaytime}</div>
          <div className={styles.filters}>
            <div>
              <DropdownRadioMenuFilter
                label=""
                listOfItems={playtimeFilters}
                selectedItem={currPlaytimeFilter}
                handleFilterChange={(el) => setCurrPlaytimeFilter(el)}
              />
            </div>
            <div className={styles.marginLeft}>
              <DropdownRadioMenuFilter
                label=""
                listOfItems={playtimePeriods}
                selectedItem={currPlaytimePeriod}
                handleFilterChange={(el) => setCurrPlaytimePeriod(el)}
              />
            </div>
          </div>
        </div>
      </div>

      {data && currPlaytimeFilter && avarageAmount !== 0 ? (
        <div className={styles.body}>
          <BarChartComponent data={data} currPlaytimeFilter={currPlaytimeFilter} timeFormatter={timeFormatter} />
          <div className={styles.avarage}>
            {currPlaytimeFilter && currPlaytimeFilter.value === 'importoTot' ? (
              <span>
                <p>{avarageAmount && formatter.format(getAmount(avarageAmount))}</p>
                <p>{avarageAmount && dashboardPage.testoImportoMedio}</p>
              </span>
            ) : (
              <span>
                <p>{avarageTime && timeFormatter(avarageTime)}</p>
                <p>{avarageTime && dashboardPage.testoTempoMedio}</p>
              </span>
            )}
            <span>
              <p>{bestResult}</p>
              <p>{bestResult && dashboardPage.testoCategoriaPreferita}</p>
            </span>
          </div>
        </div>
      ) : (
        <NoResult noMargin transparent label={'Nessun risultato'} />
      )}
    </Wrapper>
  );
};
